import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Room from './Room';
import Mypage from './Mypage';
import Ranking from './Ranking';



import LoginPage from './login.js';
import RegisterPage from './register.js';
import reportWebVitals from './reportWebVitals'; // アナリティクス用。 
import TopPage from './top.js';
import SearchPage from './search.js';
import StreamView from './StreamView';
import OwnerConsole from './OwnerConsole';
import Tutorial from './Tutorial';
import TutorialRoom from './components/tutorial/TutorialRoom';
import BetaTestPage from './components/betaTest/BetaTestPage';
console.log('index rendered');

// const loginRoot = ReactDOM.createRoot(document.getElementById('app'));
const App = ReactDOM.createRoot(document.getElementById('app'));

// App.render(
//   <React.StrictMode>
//       <SseTest />
//   </React.StrictMode>
// );


App.render(
  // <React.StrictMode>
    // <ThemeProvider theme={theme}>
    //   <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/room" element={<Room page="member" />} />
          <Route path="/owner" element={<Room page="owner" />} />
          <Route path="/mypage" element={<Mypage/>} />
          <Route path="/ranking" element={<Ranking />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/stream/:eventId" element={<StreamView />} />
          <Route path="/owner-console/:eventId" element={<OwnerConsole />} />
          <Route path="/tutorial" element={<Tutorial />} />
          <Route path="/tutorial/room" element={<TutorialRoom />} />
          <Route path="/event/2026-beta" element={<BetaTestPage />} />
          <Route path="/" element={<TopPage/>} />
        </Routes>
      </BrowserRouter>
    // </ThemeProvider>
  // </React.StrictMode>
);


reportWebVitals();
